import { useEffect } from 'react';

function Schedule() {
  useEffect(() => {
    window.location.href =
      'https://eskolare.pipedrive.com/scheduler/wWWJb9Ua/reuniao-de-demonstracao-eskolare';

    return () => {};
  }, []);
  return <div style={{ height: '70vh' }}></div>;
}

export default Schedule;
